import { ComboboxItem, Stack, Text, Tooltip } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { notifications } from '@mantine/notifications';
import React from 'react';
import classes from './DropZone.module.css';
import { DROPZONE_ACCEPT, SUPPORTED_FORMATS_LABEL } from '../allowedFileTypes';

type Props = {
  documentType: ComboboxItem;
  onFilesSelected: (files: File[]) => void;
  onOneDriveClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export function DropZone({ onFilesSelected, onOneDriveClick }: Props) {
  const handleFilesSelected = (files: File[]) => {
    onFilesSelected(files);
  };

  return (
    <>
      <Dropzone
        onDrop={handleFilesSelected}
        onReject={fileRejections => {
          fileRejections.forEach(fileRejection => {
            notifications.show({
              title: `Failed to upload ${fileRejection.file.name}`,
              message: `This file type is not supported. Supported formats: ${SUPPORTED_FORMATS_LABEL}.`,
              color: 'red',
            });
          });
        }}
        maxSize={2147483648} // 2GB
        style={{
          border: '1px dashed #b4bbc7',
          borderRadius: '16px',
          padding: '32px',
        }}
        accept={DROPZONE_ACCEPT}
      >
        <Stack justify={'center'} align={'center'} style={{ width: '100%' }}>
          <Text size="lg" fw={600} ta={'center'}>
            Add your clients data here, either from{' '}
            <Text span size="lg" className={classes.uploadLabel} onClick={e => onOneDriveClick(e)}>
              SharePoint
            </Text>{' '}
            or{' '}
            <Text span size="lg" className={classes.uploadLabel}>
              upload from your computer
            </Text>
          </Text>
          <Tooltip label={SUPPORTED_FORMATS_LABEL} position="top" withArrow>
            <Text size="xs" className={classes.fileTypesLabel} style={{ alignSelf: 'flex-end' }}>
              Supported file types
            </Text>
          </Tooltip>
        </Stack>
      </Dropzone>
    </>
  );
}
